import {connect} from "react-redux"
import {createSelector} from "reselect"
import {IncomingHttpHeaders} from "http"
import {QuickLinkProps} from "../QuickLink"
import {State} from "../../ducks"
import {SupportedRegionTypes, SupportedRegionSubTypes} from "../../models/regions"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import {REALM_HEADER} from "../../config/constants"

const requestSelector = (state: State) => state.request
const settingsSelector = (state: State) => state.settings
const dataSelector = (state: State) => state.data

const quickLinksSelector = createSelector(
    dataSelector,
    requestSelector,
    settingsSelector,
    (data, request, settings) => {
        const {siteUrl} = request
        const {variant, iconsVersionPath} = settings
        const realm = (request.headers as IncomingHttpHeaders)[REALM_HEADER] as string
        const quickLinkObject = data?.regions.find(region => region.type === SupportedRegionTypes.QuickLinks)
        return quickLinkObject?.elements
            .filter(link => link.type === SupportedRegionSubTypes.Link)
            .map(({text, url, accessibilityText, icon}) => {
                const iconUrl = icon ? formatCdnPathWithVariant(icon, realm, variant, iconsVersionPath) : null
                return {
                    text,
                    url: `${siteUrl}${url}`,
                    accessibilityText: accessibilityText ?? "",
                    icon: iconUrl,
                } as QuickLinkProps
            })
    },
)

export const mapStateToProps = (state: State) => {
    return {
        quickLinks: quickLinksSelector(state),
    }
}

export default connect(mapStateToProps)
